module.exports = __webpack_public_path__ + "img/nissin-3.1f3e4569.jpg";